import { useState, useEffect } from "react";
import { GoMute, GoUnmute } from "react-icons/go";
import TrainerImg from "../../assets/images/png/trainerBannerImg.png";
import Anywhere from "../../assets/images/png/homepageGraphic.png";
import OmniActiveMain from "../../assets/videos/mp4/omniActiveMainIntro.mp4";
import OmniPhoneIntro from "../../assets/videos/mp4/omniIntroForPhone.mp4";
import { Fade } from 'react-reveal';
import Zoom from 'react-reveal/Zoom';

import CONSTANTS from "../../utils/constants/CONSTANTS";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const OverviewBanner = () => {
  const [muted, setMuted] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => handleWindowSizeChange());
  }, []);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  const handleSignupEvent = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From sign up button in overview page banner", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From sign up button in overview page banner", "Redirection");
  };

  const handleSound = () => {
    setMuted(!muted);
  };

  return (
    <div className="overview-wrapper">
      <Zoom>
        <div className="video-components">
          <video
            className="header-video"
            preload="true"
            controlsList="nodownload"
            autoPlay="autoplay"
            loop="true"
            muted={muted}
            playsinline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            {width < 600 ? (
              <source src={OmniPhoneIntro} data-wf-ignore="true" />
            ) : (
                <source src={OmniActiveMain} data-wf-ignore="true" />
              )}
            <source src={OmniActiveMain} data-wf-ignore="true" />
          </video>
        </div>
      </Zoom>
      {muted ? (
        <GoMute className="sound-btn" style={CONSTANTS.EXTRA_BIG_ICON} onClick={handleSound} />
      ) : (
          <GoUnmute className="sound-btn" style={CONSTANTS.EXTRA_BIG_ICON} onClick={handleSound} />
        )}

      <div className="overview-banner">
        <Fade left>
          <div className="left">
            <div className="logo-image">
              <img className="anywhere-img" src={Anywhere} alt="anywhere" />
            </div>
          </div>
        </Fade>
        <Zoom>
          <div className="middle">
            <img src={TrainerImg} className="image" alt="Female Athlete" />
          </div>
        </Zoom>
        <Fade right>
          <div className="right">
            <div className="circular-button" onClick={handleSignupEvent}>
              Sign up
          </div>
            <div className="small-text">Start your fitness journey with us</div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default OverviewBanner;
